import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { TrashIcon } from "../../utils/icons";
import { useCart } from "../../context/CartContext";
import { formatCurrency } from "../../utils/formatters";

export default function CartItem({ item }) {
  const { updateQuantity, removeFromCart } = useCart();

  return (
    <motion.li
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      layout
      className="flex py-6 group"
    >
      <motion.div
        whileHover={{ scale: 1.05 }}
        className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200 group-hover:border-primary-500 transition-colors duration-300"
      >
        <motion.img
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.6 }}
          src={item.image}
          alt={item.name}
          className="h-full w-full object-cover object-center"
        />
      </motion.div>

      <div className="ml-4 flex flex-1 flex-col">
        <div>
          <div className="flex justify-between text-base font-medium text-gray-900">
            <motion.h3 whileHover={{ color: "#DB5461" }}>
              <Link
                to={`/products/${item.id}`}
                className="text-[#DB5461] hover:text-[#DB5461]/80 transition-colors duration-300"
              >
                {item.name}
              </Link>
            </motion.h3>
            <motion.p whileHover={{ scale: 1.05 }} className="ml-4 font-serif">
              {formatCurrency(item.price)}
            </motion.p>
          </div>
          <p className="mt-1 text-sm text-gray-500">{item.category}</p>
        </div>
        <div className="flex flex-1 items-end justify-between text-sm">
          <div className="flex items-center space-x-3">
            <label htmlFor={`quantity-${item.id}`} className="text-gray-500">
              Qty
            </label>
            <select
              id={`quantity-${item.id}`}
              value={item.quantity}
              onChange={(e) => updateQuantity(item.id, Number(e.target.value))}
              className="rounded-md border-gray-300 py-1.5 text-base leading-5 focus:border-[#DB5461] focus:outline-none focus:ring-[#DB5461] sm:text-sm"
            >
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
          </div>

          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            type="button"
            onClick={() => removeFromCart(item.id)}
            className="text-[#DB5461] hover:text-[#DB5461]/80 transition-colors duration-300"
          >
            <TrashIcon className="h-5 w-5" />
          </motion.button>
        </div>
      </div>
    </motion.li>
  );
}
